// Serviços de Clientes usando Axios compartilhado (baseURL vem de REACT_APP_API_BASE)
import api from '../config/axios';

export async function listClientes() {
  return api.get('/api/clientes');
}

export async function getCliente(id) {
  return api.get(`/api/clientes/${id}`);
}

export async function createCliente(data) {
  return api.post('/api/clientes', data);
}

export async function updateCliente(id, data) {
  return api.put(`/api/clientes/${id}`, data);
}

export async function deleteCliente(id) {
  return api.delete(`/api/clientes/${id}`);
}

export async function getClientesSchema() {
  return api.get('/api/schema/clientes');
}
